import { render, staticRenderFns } from "./FotoGaleria.vue?vue&type=template&id=581e97be&scoped=true&"
import script from "./FotoGaleria.vue?vue&type=script&lang=js&"
export * from "./FotoGaleria.vue?vue&type=script&lang=js&"
import style0 from "./FotoGaleria.vue?vue&type=style&index=0&id=581e97be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e97be",
  null
  
)

export default component.exports